import React from 'react'
import { cn } from '@/lib/utils'
import './odin-button.css'
import { buttonVariants, buttonSizes } from '@/lib/odin-button-variants'

const OdinButton = React.forwardRef(({ 
  className,
  variant = 'primary',
  size = 'regular',
  disabled = false,
  leftIcon,
  rightIcon,
  children,
  ...props
}, ref) => {
  return (
    <button
      className={cn(
        'odin-btn',
        buttonVariants[variant],
        buttonSizes[size],
        disabled && 'odin-btn-disabled',
        className
      )}
      disabled={disabled}
      ref={ref}
      {...props}
    >
      {leftIcon && <span className="odin-btn-icon-left">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="odin-btn-icon-right">{rightIcon}</span>}
    </button>
  )
})

OdinButton.displayName = 'OdinButton'

export { OdinButton }